module.exports = __webpack_public_path__ + "assets/img/product_direkt@2x.2e6a3ad7.jpg";